module.exports = __webpack_public_path__ + "static/media/cracked.c801c64a.gltf";